var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.toolbar)?_c('v-app-bar',{attrs:{"app":""}}):_vm._e(),_c('v-main',{staticClass:"grey lighten-2"},[(_vm.loaded)?_c('div',{staticClass:"fill-height"},[(_vm.isRoute('mobile1'))?_c('mobile-1'):_vm._e()],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }